import React, { useEffect, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import * as types from '../../redux/constantes/job'

import { UploadJobAction } from '../../redux/actions/job'

import { ModalProps } from '../../types/components/modal'
import { Wrapper, Wrapper2 } from '../Wrapper'
import { InputFile } from '../InputFile'
import { InputText } from '../InputText'
import { LGPD } from '../LGPD'
import { MessageBoxAlert, MessageBoxError, MessageBoxSuccess } from '../MessageBox'
import { ModalStyle, WrapperButtonsModal, ButtonModal } from './style'
import { useHistory } from 'react-router-dom'
import { Select } from '../Select'

export const Modal: ModalProps = ({ setActiveModal, office, question1, question2, activeQuestionSalary }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { loading, success, error } = useSelector((state: RootStateOrAny) => state.uploadJob)

  const [fullName, setFullName] = useState<string>()
  const [cellPhone, setCellPhone] = useState<string>()
  const [respQuestion1, setRespQuestion1] = useState<string>()
  const [respQuestion2, setRespQuestion2] = useState<string>()
  const [respQuestion3, setRespQuestion3] = useState<string>()

  const [file, setFile] = useState<File | null>(null)
  const [errorFile, setErrorFile] = useState(false)

  const [isVerify, setIsVerify] = useState(false)
  const [isValidateCaptcha, setIsValidateCaptcha] = useState(false)
  const [activeQuestions, setActiveQuestions] = useState(false)

  useEffect(() => {
    if (question1 || question2 || activeQuestionSalary) {
      setActiveQuestions(true)
    }
  }, [question1, question2, activeQuestionSalary])

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        dispatch({ type: types.UPLOAD_JOB_RESET })
        history.push('/curriculo-enviado')
      }, 2000)
    }
    if (error) {
      setTimeout(() => {
        dispatch({ type: types.UPLOAD_JOB_RESET })
      }, 5000)
    }
    if (errorFile) {
      setTimeout(() => {
        setErrorFile(false)
      }, 3000)
    }
  }, [success, error, errorFile])

  const onSubmit = () => {
    if (file !== null && fullName !== undefined && cellPhone !== undefined) {
      dispatch(
        UploadJobAction(
          file,
          fullName,
          office,
          cellPhone,
          question1,
          respQuestion1 !== undefined ? respQuestion1 : '',
          question2,
          respQuestion2 !== undefined ? respQuestion2 : '',
          activeQuestionSalary ? 'Qual sua pretensão salarial: ' : '',
          respQuestion3 !== undefined ? respQuestion3 : ''
        )
      )
    } else {
      setErrorFile(true)
    }
  }

  const validateCaptcha = () => {
    setIsValidateCaptcha(true)
  }

  const expiredCaptcha = () => {
    setIsValidateCaptcha(false)
  }

  const activeButtonSend = () => {
    if (isVerify && isValidateCaptcha) {
      return false
    }
    return true
  }
  return (
    <ModalStyle>
      <section>
        <h3>Tenho interesse em {office}</h3>
        <Wrapper>
          <InputText
            label="* Nome do Candidato"
            onChange={e => setFullName(e.target.value)}
            placeholder="exemplo: Luis da Silva"
            value={fullName as string}
            widthDiv="48%"
          />
          <InputText
            useMask={true}
            layoutMask="(99) 99999-9999"
            label="* Celular/Whatsapp"
            onChange={e => setCellPhone(e.target.value)}
            placeholder="exemplo: (11) 99988-7766"
            value={cellPhone as string}
            widthDiv="48%"
          />
        </Wrapper>
        <InputFile file={file} setFile={setFile} />
        {activeQuestions && (
          <>
            <h3>Perguntas</h3>
            <Wrapper2>
              {question1 && question1.length > 0 && (
                <Select
                  text="Selecione sua resposta"
                  array={['sim', 'não']}
                  value={respQuestion1 as string}
                  handleChange={e => setRespQuestion1(e.target.value)}
                  widthDiv="30%"
                  label={`* ${question1}`}
                />
              )}
              {question2 && question2.length > 0 && (
                <Select
                  text="Selecione sua resposta"
                  array={['sim', 'não']}
                  value={respQuestion2 as string}
                  handleChange={e => setRespQuestion2(e.target.value)}
                  widthDiv="30%"
                  label={`* ${question2}`}
                />
              )}
              {activeQuestionSalary && (
                <InputText
                  useMask={true}
                  layoutMask={'R$ 99999'}
                  label="Qual a sua pretensão salarial ?"
                  onChange={e => setRespQuestion3(e.target.value)}
                  value={respQuestion3 as string}
                  widthDiv="30%"
                />
              )}
            </Wrapper2>
          </>
        )}

        <LGPD isVerify={isVerify} setIsVerify={setIsVerify} />

        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY as string}
          onChange={validateCaptcha}
          onExpired={expiredCaptcha}
        />
        {!loading && (
          <WrapperButtonsModal>
            <ButtonModal typeButton={1} onClick={() => setActiveModal(false)}>
              Voltar
            </ButtonModal>
            <ButtonModal typeButton={2} onClick={onSubmit} disabled={activeButtonSend()}>
              Enviar Currículo
            </ButtonModal>
          </WrapperButtonsModal>
        )}
        {loading && <MessageBoxAlert>Aguarde o envio dos dados...</MessageBoxAlert>}
        {success && <MessageBoxSuccess>{success}</MessageBoxSuccess>}
        {error && <MessageBoxError>{error}</MessageBoxError>}
        {errorFile && (
          <MessageBoxError>Selecione o seu currículo e preencha os campos antes de enviar!</MessageBoxError>
        )}
      </section>
    </ModalStyle>
  )
}
